import React from 'react';
import { FilterSelect } from '../filters/FilterSelect';
import { FilterMultiSelect } from '../filters/FilterMultiSelect';
import { FilterText } from '../filters/FilterText';
import { FilterDate } from '../filters/FilterDate';
import { FilterConditional } from '../filters/FilterConditional';
import { ColumnDefinition, GridSlicerTypes } from 'features/gridReport/models';
import { getCurrentFilterValue } from '../functions/getCurrentFilterValue';
import { getCurrentFilterMultiValue } from '../functions/getCurrentFilterMultiValue';
import { FilterOptionValues } from 'features/gridReport/components/functions/loadData';

export function renderFilterComponent(
  item: ColumnDefinition,
  filterValues: { key: string; value: string }[],
  filterOptionValues: FilterOptionValues,
  countries: string[],
  onFilterChange?: (name: string, value: any) => void
): React.ReactNode {
  switch (item.filter_type) {
    case GridSlicerTypes.SELECT:
      const field =
        item.field === 'store' && filterOptionValues.bu_code
          ? 'bu_code'
          : item.field;
      const options =
        field === 'COUNTRY_CODE'
          ? countries
          : filterOptionValues[field] || [];
      return (
        <FilterSelect
          name={field}
          label={item.label}
          value={getCurrentFilterValue(filterValues, field)}
          options={options}
          onChange={onFilterChange}
        />
      );
    case GridSlicerTypes.MULTI_SELECT:
      return (
        <FilterMultiSelect
          name={item.field}
          label={item.label}
          value={getCurrentFilterMultiValue(filterValues, item.field)}
          options={filterOptionValues[item.field] || []}
          onChange={onFilterChange}
        />
      );
    case GridSlicerTypes.TEXT:
      return (
        <FilterText
          name={item.field}
          label={item.label}
          value={getCurrentFilterValue(filterValues, item.field)}
          onChange={onFilterChange}
        />
      );
    case GridSlicerTypes.DATE_PICKER:
      return (
        <FilterDate
          name={item.field}
          label={item.label}
          valueFrom={getCurrentFilterValue(filterValues, `${item.field}.gte`)}
          valueTo={getCurrentFilterValue(filterValues, `${item.field}.lte`)}
          onChange={onFilterChange}
        />
      );
    case GridSlicerTypes.CONDITIONAL:
      return (
        <FilterConditional
          name={item.field}
          label={item.label}
          value={getCurrentFilterValue(filterValues, item.field)}
          onChange={onFilterChange}
        />
      );
    default:
      return null;
  }
}
